import { render, staticRenderFns } from "./StudentRequirements.vue?vue&type=template&id=4484589b&scoped=true&"
import script from "./StudentRequirements.vue?vue&type=script&lang=js&"
export * from "./StudentRequirements.vue?vue&type=script&lang=js&"
import style0 from "./StudentRequirements.vue?vue&type=style&index=0&id=4484589b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4484589b",
  null
  
)

export default component.exports